// extracted by mini-css-extract-plugin
export default {"carBanner":"CarBanner_carBanner__WjZ2G","carJellyImage":"CarBanner_carJellyImage__CgBfW"};